module.exports = __webpack_public_path__ + "static/media/LogoMaruStd-Extra.6b6e2ec9.svg";